import * as types from '../mutation-types'
import UserApi from '../../api/UserApi'
import auth from '../../utils/auth'

const state = {
  isAuth: auth.isTokenValid(),
  userInfo: auth.user
}

const getters = {
  isAuth: state => state.isAuth,
  getUser: state => state.userInfo,
  hasTrial: state => {
    const user = state.userInfo
    if (user && user.trial_ends_at) {
      const now = new Date()
      const trial = new Date(user.trial_ends_at)
      return now < trial
    }
    return false
  }
}

const actions = {
  async login ({ dispatch }, { email, password }) {
    try {
      const userObj = await UserApi.login(email, password)
      dispatch('setUser', userObj)
      return userObj
    } catch (e) {
      dispatch('logout')
      return Promise.reject(e)
    }
  },

  refreshToken () {
    return UserApi.refreshToken()
  },

  setUser ({ commit }, userObj) {
    commit(types.LOGIN_USER, userObj)
  },

  logout ({ commit }) {
    UserApi.logout()
    commit(types.LOGOUT_USER)
  },

  async updateGdpr ({ commit }, value) {
    await UserApi.updateGdpr(value)
    const user = await UserApi.getUser()
    commit(types.UPDATE_GDPR, user.accepted_dpp)
  },

  async updateUser ({ dispatch }) {
    const newUserObj = await UserApi.getUser()
    dispatch('setUser', newUserObj)
    auth.user = newUserObj
    return newUserObj
  }
}

const mutations = {
  [types.LOGIN_USER] (state, userObj) {
    state.isAuth = Boolean(userObj)
    state.userInfo = userObj
  },
  [types.LOGOUT_USER] (state) {
    state.isAuth = false
    state.userInfo = null
  },
  [types.UPDATE_GDPR] (state, value) {
    state.userInfo.accepted_dpp = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
